export const commonStyles: Record<string, React.CSSProperties> = {
  fontSize: {
    fontSize: '10pt',
  },
  marginBottom: {
    marginBottom: '10px',
  },
  lineHeight: {
    lineHeight: '1.4',
  },
  marginTop: {
    marginTop: '10px',
  },
  linkStyle: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: '#063d8f',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  boldTextStyle: {
    color: '#404040',
    fontSize: '10.5pt',
  },
  nuggetList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
  },
  iconStyle: {
    cursor: 'pointer',
    color: '#063d8f',
    display: 'flex',
    alignSelf: 'center',
    justifyContent: 'center',
    height: '20px',
    padding: '0px 10px 0px 0px',
  },
  relevanceBox: {
    fontSize: '10pt',
    display: 'flex',
    padding: '10px',
    color: '#333',
    marginTop: '10px',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
  },
  descriptionBox: {
    color: '#000',
    marginTop: '10px',
  },
};
